import { createSlice } from '@reduxjs/toolkit';
import ServicesMap from 'data/mock/services.json';
import BAMapping from 'data/mock/businessAreaAndServices.json';

import { ISettingsState } from './settings-interface';
import reducer from './settings-reducer';

const initialState: ISettingsState = {
  userAccount: {},
  bootstrap: {
    services: ServicesMap.services,
    businessAreas: BAMapping.businessAreas,
    features: {}
  },
  permissions: [],
  businessArea: undefined,
  service: undefined,
  currentFile: undefined,
  isDisclaimerModal: false,
  isLoading: false,
  hash: undefined,
  currentSummary: undefined,
  summaryEdited: false,
  isFeedbackConfirmation: false,
  regenerateExtraction: null,
  isGeneratingExtraction: false,
  emailChain: undefined,
  isBetaWelcomeModal: false,
  currentSupportPath: 'feedback',
  selectedHighlight: undefined,
  highlightCoords: undefined,
  showHighlights: false,
  isSelectLanguageModal: false,
  selectedLanguage: 'English',
  inputSize: undefined,
  isEstimatedCostModal: false,
  coverageCheckV2Id: undefined,
  coverageCheckV2Files: {
    claims: undefined,
    policy: undefined,
    terms: undefined,
    extra: undefined
  },
  userRoles: undefined,
  userBusinessUnits: undefined,
  selectedBusinessUnit: 'default',
  selectedDocuments: [],
  canSelectDocuments: true
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: reducer
});

export const settingsReducer = settingsSlice.reducer;
